/**
* Three Image CTA JS
* -----------------------------------------------------------------------------
*
* All the JS for the Three Image CTA component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
// gsap.registerPlugin( ScrollTrigger );
( function( app ) {
  const COMPONENT = {

    className: 'three-image-cta',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      // const blog = $( '.bg-gradient-linear-circle' );
      // gsap.set( blog, {scale: 0.5, transformOrigin: 'center center'} );

      // gsap.to( blog, {
      //   scale: 1,
      //   duration: 2,
      //   repeat: -1,
      //   yoyo: true,
      //   ease: 'sine.inOut',
      // } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'three-image-cta', COMPONENT );
} )( app );
